export const exrTypeList = [
    {id: 1, label: '选出你听到的词'},
    {id: 2, label: '听录音，选翻译'},
    {id: 3, label: '看词语、选翻译'},
    {id: 4, label: '看翻译，选词语'},
    {id: 5, label: '看词语，选图片'},
]

export const pdtTypeList = [
    {id: 101, label: '翻译-汉字'},
    {id: 102, label: '音频-翻译'},
    {id: 103, label: '翻译-汉字填空'},
    {id: 104, label: '音频-词语'},
    {id: 105, label: '词语-图片'},
]